window.addEventListener('load', function () {
  let scrollContainer = document.querySelector('.horizontal-parallax')

  if (scrollContainer) {
    if (window.innerWidth > 768) {
      let horiTL = gsap.timeline({
        paused: true,
        scrollTrigger: {
            trigger: scrollContainer,
            start: 'top 100px',
            end: () => "+=" + (scrollContainer.offsetWidth * 4),
            scrub: true,
            pin: true,
            invalidateOnRefresh: true,
            // markers: true
        }
      })

      horiTL.to({}, {duration: .5})
      horiTL.to('.parallax-item', {
        right: 0,
        duration: 2,
        ease: 'none',
        stagger: 2
      })
      horiTL.to({}, {duration: .5})
    }
  }
})